import React from "react";
import { PiXBold } from "react-icons/pi";

/**
 * Small presentational pieces shared across admin sections. Each one mirrors a
 * repeated inline-styled fragment from the handoff prototype.
 */

/** Coloured dot + label, the prototype's status treatment for payments,
 *  request stages and ticket severity. */
export const StatusDot = ({ color, label, className = "", style }) => (
  <span className={`admin-status ${className}`} style={{ color, ...style }}>
    <span className="admin-status-dot" style={{ background: color }} />
    {label}
  </span>
);

/** "Tier n of 3" plus the 14x4 strip meter used in the users table. */
export const TierMeter = ({ tier, total = 3 }) => (
  <div className="admin-tier">
    <span className="admin-tier-label">Tier {tier} of {total}</span>
    <div className="admin-tier-dots">
      {Array.from({ length: total }, (_, i) => (
        <span key={i} className={`admin-tier-dot ${i < tier ? "admin-tier-dot--on" : ""}`} />
      ))}
    </div>
  </div>
);

/** Full-width version of the same meter, used in the user drawer. */
export const TierBars = ({ tier, total = 3 }) => (
  <div className="admin-tier-bars">
    {Array.from({ length: total }, (_, i) => (
      <span key={i} className={`admin-tier-bar ${i < tier ? "admin-tier-bar--on" : ""}`} />
    ))}
  </div>
);

/** Native-radio segmented control from the design system. */
export const Segmented = ({ name, options, value, onChange }) => (
  <div className="seg">
    {options.map((opt) => (
      <label className="seg-opt" key={opt.value}>
        <input
          type="radio"
          name={name}
          checked={value === opt.value}
          onChange={() => onChange(opt.value)}
        />
        {opt.label}
      </label>
    ))}
  </div>
);

export const SelectFilter = ({ value, onChange, options, minWidth = 170 }) => (
  <select
    className="input"
    style={{ width: "auto", minWidth }}
    value={value}
    onChange={(e) => onChange(e.target.value)}
  >
    {options.map((o) => (
      <option key={o.value} value={o.value}>{o.label}</option>
    ))}
  </select>
);

export const SectionLabel = ({ children }) => (
  <div className="admin-section-label">{children}</div>
);

/** Right-aligned "n of m" counter used at the end of every toolbar. */
export const CountLabel = ({ shown, total, noun }) => (
  <div className="admin-count">{shown} of {total} {noun}</div>
);

/** Shown when a filter or search excludes everything. The brief asks for
 *  populated placeholder data, so this only appears on user action. */
export const NoResults = ({ colSpan, label = "Nothing matches those filters." }) => (
  <tr>
    <td colSpan={colSpan} style={{ padding: "28px 16px", textAlign: "center", opacity: 0.55 }}>
      {label}
    </td>
  </tr>
);

export const CloseButton = ({ onClick, label = "Close" }) => (
  <button type="button" className="btn btn-icon btn-secondary" onClick={onClick} aria-label={label}>
    <PiXBold />
  </button>
);
